import { Injectable } from '@angular/core';
import {
    AbstractDataServiceDtoAdapter
} from '../../../../../core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import { WorkflowTaskDataService } from './workflowTaskData.service';
import { WorkflowTaskModel } from '../../../api/model/common/workflowTask.model';
import { WorkflowTaskConverter } from '../../../api/model/common/converter/workflowTask.converter';

@Injectable()
export class WorkflowTaskDataServiceAdapter extends AbstractDataServiceDtoAdapter<WorkflowTaskModel, WorkflowTaskConverter> {
    constructor(dataService: WorkflowTaskDataService, converter: WorkflowTaskConverter) {
        super(dataService, converter);
    }

    newStoredEntityInstance(): WorkflowTaskModel {
        return new WorkflowTaskModel();
    }
}
